import type { AbrangenciaDoServico } from "@bookdental/schemas";

/** Configurando vários serviços: o que todos têm (marcado), o que só parte tem (parcial) e a
 *  abrangência comum (nula quando diferem). */
export function estadoInicialDoGrupo(chaves: string[], mapa: Record<string, string[]>, abrangenciaDe: (chave: string) => AbrangenciaDoServico) {
  const listas = chaves.map((c) => mapa[c] ?? []);
  const uniao = [...new Set(listas.flat())];
  const comuns = uniao.filter((m) => listas.every((l) => l.includes(m)));
  const parciais = uniao.filter((m) => !comuns.includes(m));
  const abrangencias = new Set(chaves.map(abrangenciaDe));
  return { comuns, parciais, abrangencia: abrangencias.size === 1 ? [...abrangencias][0]! : null };
}

/**
 * O que cada serviço fica tendo: o marcado vale pra todos; o parcial que a pessoa não tocou fica só
 * em quem já tinha; o resto sai. Assim configurar em grupo nunca apaga o ajuste feito um a um sem
 * a pessoa mexer naquele material.
 */
export function materiaisDoGrupo(chaves: string[], mapa: Record<string, string[]>, marcados: string[], parciaisRestantes: string[]) {
  return Object.fromEntries(
    chaves.map((c) => {
      const ficam = (mapa[c] ?? []).filter((m) => parciaisRestantes.includes(m));
      return [c, [...new Set([...ficam, ...marcados])]];
    }),
  );
}
